import { Autocomplete, AutocompleteProps, TextField } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import * as S from './styles';

interface StyledAutocompleteProps<T> extends Partial<AutocompleteProps<T, false, false, false>> {
  options: T[];
  className?: string;
}

const StyledAutocomplete = <T,>({ options, className, ...rest }: StyledAutocompleteProps<T>) => {
  return (
    <S.Container className={className}>
      <Autocomplete
        autoHighlight
        options={options}
        renderInput={(params) => <TextField variant='outlined' {...params} />}
        popupIcon={<ChevronDown />}
        componentsProps={{
          paper: {
            elevation: 0,
          },
          popupIndicator: {
            disableRipple: true,
          },
        }}
        {...rest}
      />
    </S.Container>
  );
};

export default StyledAutocomplete;
